import { render, staticRenderFns } from "./MaterialUsage.vue?vue&type=template&id=c5888690&"
import script from "./MaterialUsage.vue?vue&type=script&lang=js&"
export * from "./MaterialUsage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports